const getHostName = () => {
  const hostname = process.env.REACT_APP_HOST ? process.env.REACT_APP_HOST : "";
  return hostname;
};

export const getAuthEndpoint = () => {
  return process.env.REACT_APP_AUTHENDPOINT;
};

export const getAPIEndpoint = () => {
  if (document) {
    if (document.getElementById("apiUrl"))
      return document.getElementById("apiUrl").value;
  }
  return process.env.REACT_APP_APIENDPOINT;
};

export const getFlowAPIEndpoint = () => {
  if (document) {
    if (document.getElementById("flowApiUrl"))
      return document.getElementById("flowApiUrl").value;
  }
  return process.env.REACT_APP_FLOWAPIENDPOINT;
};

export default getHostName;
